import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button";
import { AuthContext } from '../../../../contexts/AuthContext';
import { TransactionStatus } from '../../../../interfaces/transaction.interface';
import { Modules, RouteParamsTypes, PermissionModulesEnum, PermissionActionsEnum } from "../../../../enums";
import { hasResourseAccess } from '../../../../utils/methods';
import { VALIDATION_FIELD_MAPPING } from "../../../../utils/appConstant";

interface HeaderProps {
  id?: string;
  view: boolean;
  edit: boolean;
  loading: boolean;
  transactionStatus: TransactionStatus;
  onDelete?: () => void;
}

const Header: React.FC<HeaderProps> = ({ id, view, edit, loading, transactionStatus, onDelete }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasAddAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Transaction]: [PermissionActionsEnum.Add] }] })
  const hasEditAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Transaction]: [PermissionActionsEnum.Update] }] })
  const hasListAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Transaction]: [PermissionActionsEnum.View] }] })

  const handleGoToListClick = () => {
    navigate(Modules.transactions);
  };

  const handleEditButtonClick = () => {
    navigate(`${Modules.transactions}${RouteParamsTypes.edit}/${id}`);
  }

  const handleAddNewClick = () => {
    navigate(`${Modules.transactions}${RouteParamsTypes.add}`);
  };

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t("transactions.addEdit.pageTexts.header.title")}</h4>
        <p>{t("transactions.addEdit.pageTexts.header.subTitle")}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end gap-3">
        {
          edit && hasAddAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light mt-xs-3"
              text={t("transactions.addEdit.pageTexts.header.addNew")}
              onClick={handleAddNewClick}
            />
          )
        }

        {
          view && !loading && (transactionStatus === VALIDATION_FIELD_MAPPING.unBilled) && (
            <Button
              className="btn btn-danger waves-effect waves-light mt-xs-3"
              text={t("transactions.addEdit.pageTexts.header.deleteBtn")}
              onClick={onDelete}
            />
          )
        }

        {
          view && !loading && hasEditAccess && (transactionStatus != VALIDATION_FIELD_MAPPING.settled) && (
            <Button
              className="btn btn-primary waves-effect waves-light mt-xs-3"
              text={t("transactions.addEdit.pageTexts.header.editBtn")}
              onClick={() => handleEditButtonClick()}
            />
          )
        }

        {
          hasListAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light"
              onClick={handleGoToListClick}
              text={t("transactions.addEdit.pageTexts.header.goToList")}
            />
          )
        }
      </div>
    </div>
  );
}

export default Header;